import { APIClient } from "./axiosClient";
import { ResponseData } from "./types/_public";
import { AxiosResponse } from "axios";
import { IUser } from "./types/_user";
const api = new APIClient();

const path = "/settings";
const pathAI = "/ai-settings";

const SettingApi = {
  getSetting(): Promise<any> {
    const url = `${path}/app`;
    return api.get(url);
  },

  postSetting(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `${path}/app`;
    return api.post(url, dataForm);
  },

  getAISetting(): Promise<any> {
    const url = `${pathAI}`;
    return api.get(url);
  },

  postAISetting(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `${pathAI}`;
    return api.post(url, dataForm);
  },

  putAISetting(id: number, dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `${pathAI}/${id}`;
    return api.put(url, dataForm);
  },

};

export default SettingApi;
